import { crudAdStyle } from './crud-ad-style';
import { underlineLinkStyle } from './shared-styles-from-theme-fluent';

export const summaryPageStyle = ({ palette = {} }) =>
  ({
    '& .recommendation-summary-view': {
      '& >.toolbar': {
        marginLeft: 10,
        '& .upper-toolbar': {
          display: 'inline-block',
        },
      },
      '& .empty-buttons': {
        marginTop: 36,
      },

      // empty view
      '& .empty-filter-view': {
        margin: '32px 10px 32px 32px',

        '& .empty-icon': {
          display: 'none',
        },

        '& .empty-details': {
          color: '#605E5C',
          gridRow: '1',
          gridColumn: '2',
          '& .empty-title': {
            fontSize: 26,
            margin: '0 0 8.5px',
          },
          '& .empty-sub-title': {
            fontSize: 14,
            fontWeight: 'normal',
            ...underlineLinkStyle({ palette }),
          },
        },
      },

      // summary cards
      '& .recommendation-summary-cards': {
        width: '100%',
        minWidth: 1000,
        maxWidth: 1200,
        transformStyle: 'preserve-3d',
        '& .btn-primary': {
          fontFamily: '\'Segoe UI\', Arial, sans-serif',
          fontSize: 14,
          height: '32px',
          backgroundColor: palette.themePrimary,
          color: palette.white,
          padding: '5px 10px',
          borderRadius: '2px',
          margin: '0 5px 0 0',
          '&:hover': {
            backgroundColor: '#106ebe',
          },
        },
        '& .recommendation-summary-card': {
          minHeight: 120,
          marginBottom: 20,
          width: 500,
          border: 'solid 1px #dddddd',
          boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.108), 0px 1.6px 3.6px rgba(0, 0, 0, 0.132)',
          fontFamily: '\'Segoe UI\', Arial, sans-serif',
          fontSize: 12,
          color: '#333333',
          display: 'grid',
          gridTemplateColumns: '100%',
          gridTemplateRows: 'repeat(4,auto)',
          borderRadius: '2px',
          '& .summary-header': {
            paddingTop: '8px',
            paddingRight: '16px',
            paddingLeft: '16px',
            paddingBottom: '8px',
            gridRow: '1',
            '& .recommendation-summary-header': {
              display: 'grid',
              gridTemplateColumns: '24px min-content auto 40px',
              '-ms-grid-columns': '24px auto 1fr 15px',
              gridTemplateRows: 24,
              alignItems: 'center',
              '& .summary-header-icon': {
                gridColumn: '1',
                justifySelf: 'stretch',
                alignSelf: 'center',
                position: 'relative',
                borderRadius: '50%',
                width: 24,
                height: 24,
                '& span': {
                  color: palette.white,
                  position: 'absolute',
                  fontSize: 13,
                  left: '25%',
                  right: '25%',
                  top: '25%',
                  bottom: '25%',
                },
              },
              '& .summary-header-title': {
                padding: '2px 0 2px 8px',
                gridColumn: '2',
                fontSize: 14,
                color: '#323130',
                fontWeight: '500',
                whiteSpace: 'nowrap',
              },
              '& .summary-header-label': {
                alignSelf: 'center',
                marginLeft: 8,
                gridColumn: '3',
                fontSize: 12,
                background: '#EFF6FC',
                border: '1px solid #FFFFFF',
                boxSizing: 'border-box',
                borderRadius: 12,
                width: 48,
                padding: '0 10px 0 10px',
              },
              '& .summary-header-menu': {
                gridColumn: '4',
                justifySelf: 'right',
                '& .toggle-context-menu': {
                  cursor: 'pointer',

                  '& button': {
                    background: 'none',
                    border: 'none',
                    margin: 0,
                    padding: 0,
                  },
                },
              },
              '& .summary-context-menu': {
                '& .bingads-popover': {
                  background: '#fff',
                  border: '1px solid #ddd',
                  boxShadow: '3px 3px 4px #ddd',
                  top: 'inherit !important',
                  left: 'inherit !important',
                  '& >ul': {
                    minWidth: 170,
                    listStyle: 'none',
                    margin: '0',
                    padding: '0',
                    '& button': {
                      margin: '0',
                      padding: '7px 10px',
                      color: '#333',
                      fontWeight: 'normal',
                      textAlign: 'left',
                      '&[disabled]': {
                        opacity: 0.5,
                      },
                      '&:hover': {
                        textDecoration: 'none',
                        background: '#e5e5e5',
                      },
                    },
                  },
                },
              },
            },
          },
          '& .summary-summary': {
            paddingRight: '24px',
            paddingLeft: '24px',
            paddingTop: '24px',
            borderTop: 'solid 1px #dddddd',
            gridRow: '2',
            gridTemplateRows: 'repeat(2,auto)',
            '& .summary-banner': {
              background: '#DDDDDD',
              gridRow: '1',
              '& .summary-banner-title': {
                fontWeight: 'bold',
                color: '#333333',
                height: 30,
                padding: '0px 20px',
              },
            },
            '& .summary-summary-content': {
              borderBottom: 'solid 1px #dddddd',
              display: 'grid',
              gridRow: '3',
              paddingBottom: '38px',
              gridTemplateColumns: '125px 16px',
              '& .summary-info': {
                gridColumn: '3',
                '& .summary-description': {
                  fontSize: 16,
                  lineHeight: '22px',
                  fontWeight: 'bold',
                  color: '#323130',
                },
                '& .summary-pitching': {
                  fontSize: 12,
                  lineHeight: '16px',
                  fontWeight: 'normal',
                  color: '#797775',
                  marginTop: 8,
                  '& > span': {
                    ...underlineLinkStyle({ palette }),
                  },
                },
              },
            },
            '& .summary-estimates': {
              gridColumn: '1',
            },
          },
          '& .summary-sample': {
            paddingRight: '16px',
            paddingLeft: '16px',
            paddingTop: '16px',
            gridRow: '3',
            '& .recommendation-sample': {
              '& .sample-insight-title': {
                fontSize: 13,
                fontWeight: 'bold',
                color: '#323130',
              },
              '& .sample-insight': {
                margin: '10px 0 0 0',
                fontSize: 13,
                fontWeight: 'normal',
                color: '#666666',
              },
              '& .sample-visual, & .sample-action-table': {
                margin: '15px 0 0 0',
              },
              '& .sample-horizontal-separator': {
                margin: '15px 0',
                borderTop: '1px solid #ececec',
              },
              '& .sample-action-title': {
                fontSize: 13,
                fontWeight: 'normal',
                color: '#333333',
              },
              '& .sample-more-recommendations': {
                margin: '15px 0 0 0',
              },
              '& .sample-visual .MicrosoftMap': {
                width: 'inherit !important',
                height: 'inherit !important',
                '& .InfoboxCustom': {
                  pointerEvents: 'auto',
                  /* background-color: #FFFFFF; */
                  /* background: linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), rgba(255, 255, 255, 0.25); */
                  backgroundBlendMode: 'normal, luminosity',
                  backdropFilter: 'blur(60px)',
                  boxShadow: '0px 1.2px 3.6px rgba(0, 0, 0, 0.18), 0px 6.4px 14.4px rgba(0, 0, 0, 0.22)',
                  padding: '10px',
                  /* font-family: 'Segoe UI'; */
                  '& .infobox-title': {
                    fontSize: '14px',
                    fontWeight: 600,
                  },
                },
              },
              // '& .sample-visual': {
              //   '& .advisor-chart .vnext-legend-labels-container': {
              //     display: 'none',
              //   },
              // },
            },
            ...crudAdStyle({ palette }), // TODO: remove duplicated crudAdStyle if toolbar style conflict is resolved
            '& .ad-preview-header': {
              padding: '15px 0 15px 0',
            },
            '& .recommendation-suggested-ads-column': {
              padding: '10px 10px 10px 10px',
              background: '#f5f5f5',
              '& .recommendation-summary-ad-preview': {
                width: '100%',
                padding: '15px 15px 15px 15px',
                background: palette.white,
                border: 'solid 1px #dddddd',
                boxShadow: '3px 3px 4px #dddddd',
              },
            },
          },
          '& .summary-footer': {
            paddingBottom: '16px',
            paddingRight: '16px',
            paddingLeft: '16px',
            margin: '20px 0 0 0',
            gridRow: '4',
            '& .primary-button': {
              '& button': {
                fontFamily: 'Segoe UI, Helvetica, sans-serif',
                fontWeight: 'bold',
                fontSize: 13,
                backgroundColor: palette.themePrimary,
                color: palette.white,
                padding: '5px 10px',
                margin: '0 8px 0 0',
                '&:hover': {
                  backgroundColor: '#006464',
                },
              },
            },
            '& .secondary-button': {
              '& buuton': {
                fontFamily: 'Segoe UI, Helvetica, sans-serif',
                fontWeight: 'bold',
                fontSize: 13,
                backgroundColor: palette.white,
                color: '#000000',
                padding: '5px 10px',
                border: '1px black solid',
                margin: '0 8px 0 0',
                '&:hover': {
                  backgroundColor: '#a8a8a8',
                },
              },
            },
          },
          '& .btn-default': {
            position: 'absolute',
            fontFamily: 'Segoe UI, Helvetica, sans-serif',
            fontSize: 14,
            padding: '5px 10px',
            margin: '0 5px',
            borderRadius: '2px',
            height: '32px',
            boxSizing: 'border-box',
            border: '1px solid #8A8886',
            fontWeight: 'bold',
            '&[disabled]': {
              opacity: 0.5,
            },
          },
        },
      },
    },
    // recommendation visual
    '& .action-table': {
      marginTop: 10,
      fontFamily: '\'Segoe UI\', Arial, sans-serif',
      '& thead': {
        '& th': {
          fontSize: 12,
          color: '#323130',
          fontWeight: 'bold',
          paddingBottom: '16px',
        },
      },
      '& tbody': {
        '& th': {
          fontSize: 12,
          color: '#323130',
        },
      },
      '& tr td:last-child': { // will the impressions ever be negative?
        color: '#107C10 !important',
      },
      '& tr td:not(:last-child)': {
        color: '#333333',
      },
      '& td': {
        fontSize: 13,
        fontWeight: 'normal',
        paddingBottom: 5,
        verticalAlign: 'top',
        'word-break': 'break-word',
        '& .progress-bar-with-right-label': {
          marginLeft: 10,
          alignItems: 'center',
          display: 'flex',
          '& .progress': {
            height: 7,
            marginRight: 5,
            gridRow: '1',
            gridColumn: '1',
            width: '100%',
            marginBottom: 0,
            '& .progress-bar': {
              backgroundColor: '#0078D4',
            },
          },
          '& .right-label': {
            marginLeft: '7px',
          },
        },
      },
    },
    '& .navbar-nav': {
      '& .recommendation-download': {
        paddingLeft: 20,
        paddingTop: 6,
        marginBottom: '-15px',
        '& #button-download': {
          background: '#FFFFFF',
          border: '1px solid #8A8886',
          boxSizing: 'border-box',
          borderRadius: '2px',
          fontSize: '14px',
          marginLeft: '770px',
          zIndex: '1',
        },
      },
    },
    '& .nav-pills': {
      '& li': {
        border: '1px solid #505050',
        '&.active, &.active a': {
          backgroundColor: '#e7f0f6',
          color: '#666',
          fontWeight: 'bold',
        },
        '&:nth-child(1)': {
          borderRight: '0',
        },
        '& a': {
          padding: '5px 20px 4px 20px',
          border: 'none',
          fontWeight: 'normal',
        },
      },
    },
    '& .filter-editor': {
      '& .selector-container': {
        '& button': {
          border: '1px solid #BBB',
          padding: '3px 5px 5px 5px',
          textAlign: 'right',
        },
      },
      '& .selector-v2': {
        width: 400,
      },
    },

  });
